import React from 'react';
import { Link } from 'react-router-dom';
import './Service.css';
import SEO from './components/SEO';
import Breadcrumb from './components/Breadcrumb';

function Service() {
  const breadcrumbItems = [
    { label: 'ホーム', path: '/' },
    { label: 'サービス', path: '/service' }
  ];

  return (
    <div>
      <SEO page="service" />

      <section className="ds-page-hero">
        <div className="container">
          <Breadcrumb items={breadcrumbItems} />
          <p className="ds-eyebrow">SERVICE</p>
          <h1 className="ds-h1">OSUMITSUKI</h1>
          <p className="svcpage-catch">働くを変える一歩を採用と育成から</p>
          <p className="ds-lead">
            採用・育成の業務効率化を進めながら、企業と個人の最適なマッチングと、着実な成果につながる人材育成の推進を支援。共通の評価基準による公平な選考と、データに基づく人材の見極めで、採用・育成を起点に働くを変えていきます。
          </p>
        </div>
      </section>

      <section className="ds-section">
        <div className="container">
          <div className="ds-section-head">
            <p className="ds-eyebrow">PLATFORM</p>
            <h2 className="ds-h2">
              OSUMITSUKI_Score<br />
              社会で共通の人材評価プラットフォーム
            </h2>
          </div>

          <div className="svcpage-score">
            <div className="svcpage-score-figure">
              <img src="/images/osumitsuki_score_B.jpg" alt="OSUMITSUKI Score 大画像" />
            </div>
            <div className="svcpage-score-body">
              <p className="svcpage-text">
                OSUMITSUKI Scoreは、人材の実力を可視化し、企業と個人の成長を加速させる人材評価指標プラットフォームです。
                共通の評価基準に基づいて、
              </p>
              <ul className="svcpage-score-list">
                <li className="svcpage-score-item svcpage-score-item--recruit">転職のセンター試験（共通一次面接）</li>
                <li className="svcpage-score-item svcpage-score-item--skill">スキルの通知表（社員スキルの市場比較・成長可視化）</li>
                <li className="svcpage-score-item svcpage-score-item--expansion">スキル拡張パック（1on1育成プログラム）</li>
              </ul>
              <p className="svcpage-text">
                といった各サービスを支えています。
                評価データは採用・育成・配置・昇格などライフサイクル全体で活用可能で、「誰が・いつ・どこまで成長したか」を正確に言語化します。従来属人的だった人材評価を客観的・定量的に変える新しい基盤です
              </p>
              <div className="svcpage-score-diagram">
                <img src="/images/osumitsuki_score2.jpg" alt="OSUMITSUKI Score 小画像" />
              </div>
              <Link to="/osumitsuki-score" className="ds-btn ds-btn--primary ds-btn--arrow">
                OSUMITSUKI_Score
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="ds-section ds-section--alt">
        <div className="container">
          <div className="ds-section-head">
            <p className="ds-eyebrow">SERVICES</p>
          </div>

          <div className="svcpage-grid">
            <article className="ds-card svcpage-card svcpage-card--recruit">
              <div className="svcpage-card-image">
                <img src="/images/service_recruit.jpg" alt="転職のセンター試験サービス画像" />
              </div>
              <div className="svcpage-card-body">
                <p className="svcpage-card-name">転職のセンター試験</p>
                <h3 className="ds-h3">センター試験型<wbr />転職プラットフォーム</h3>
                <p className="svcpage-text">
                  転職のセンター試験OSUMITSUKIは1度の面接で複数企業の１次面接合格判定が得られる新しい転職サービスです。
                  キャリアアセッサーが30項目以上の評価基準で候補者を査定し、合格者には2次面接確約のオファーが届きます。
                </p>
                <div className="svcpage-card-actions">
                  <a href="https://lp.p-osumitsuki.com/" target="_blank" rel="noopener noreferrer" className="ds-btn ds-btn--primary ds-btn--arrow">
                    転職をお考えの方はこちら
                  </a>
                  <a href="https://osumitsuki-b.studio.site/" target="_blank" rel="noopener noreferrer" className="ds-btn ds-btn--line ds-btn--arrow">
                    採用をお考えの方はこちら
                  </a>
                </div>
              </div>
            </article>

            <article className="ds-card svcpage-card svcpage-card--expansion">
              <div className="svcpage-card-image">
                <img src="/images/service_expansion.jpg" alt="スキルの拡張パック 画像" />
              </div>
              <div className="svcpage-card-body">
                <p className="svcpage-card-name">スキルの拡張パック</p>
                <h3 className="ds-h3">フルオーダーメイド<wbr />育成プログラム</h3>
                <p className="svcpage-text">
                  スキルの拡張パックは、TWI（Training Within Industry）をベースにした週次60分の1on1育成プログラムです。
                  PDA（People Development Architecture）の3層モデルにより、個人の課題を構造的に分析し、一人ひとりに最適化されたフルオーダーメイドの教育を提供します。
                </p>
                <div className="svcpage-card-actions">
                  <a href="https://pack.p-osumitsuki.com/" target="_blank" rel="noopener noreferrer" className="ds-btn ds-btn--primary ds-btn--arrow">
                    スキルの拡張パック
                  </a>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Service;
